import { Injectable } from '@angular/core';
import { SxHttpService } from './sxHttp.service';
import { Observable } from 'rxjs/Observable';

/**
 * Representa un Sx_Configuration en el backend
 */
export interface Sx_Configuration {
  key: string;
  value: string;
  descripcion: any;
}

@Injectable()
export class ParametrosService {
  private url = 'api/configuracionParametros';

  constructor(private sxHttp: SxHttpService) { }

  /**
   * Obtiene el listado de parametros de configuracion
   */
  getAll(): Promise<Sx_Configuration[]> {
    return this.sxHttp.get(this.url)
      .toPromise()
      .then(response => response.json().data as Sx_Configuration[]);
  }

  crearOEditar(parametro: Sx_Configuration) {
    return this.sxHttp.post(this.url, parametro)
        .toPromise()
        .then(response => response.json().data);
  }

  /**
   * Elimina el parametro de configuracion asociado con la key pasada
   */
  eliminar(key: string) {
    const url = `${this.url}/${key}`;

    return this.sxHttp.delete(url)
      .toPromise()
      .then(response => response.json().data);
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/parametros.service.ts